import { render } from "./FormMerchandise.vue?vue&type=template&id=239737bc&ts=true"
import script from "./FormMerchandise.vue?vue&type=script&lang=ts"
export * from "./FormMerchandise.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__